// extracted by mini-css-extract-plugin
export default {"tablePagination":"sM2PQfcwMZ0rITnVh4en","paginationCount":"FQ7aAdEohNWt2TunTN7X"};